export default "__VITE_ASSET__D18imj_x__"